import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "deposit-confirmed-toast__amount" }
const _hoisted_2 = { class: "deposit-confirmed-toast__currency" }

import SimpleToast from '../SimpleToast.vue';
import SimpleToastMessage from '../SimpleToastMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DepositConfirmedToast',
  props: {
  amount: { type: String, required: true },
  precision: { type: Number, required: true },
  currencyCode: { type: String, required: true },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createBlock(SimpleToast, {
    class: "deposit-confirmed-toast",
    variant: "success",
    "icon-name": "tick-circle-bulk",
    title: "modules.transactions.deposit.toasts.confirmed.title",
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
  }, {
    message: _withCtx(() => [
      _createVNode(SimpleToastMessage, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('modules.transactions.deposit.toasts.confirmed.message')), 1),
          _createVNode(_component_ot_number_display, {
            class: "deposit-confirmed-toast__number",
            number: __props.amount,
            precision: __props.precision
          }, null, 8, ["number", "precision"]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.currencyCode), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})